import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types'
import './signOut.css'

let firebase = require('firebase');

class SignOut extends Component {
  async signOut() {
    try {
      await firebase.auth().signOut();
    } catch (e) {
      console.error(e);
    }

    try {
      localStorage.removeItem("DisplayNameB4B");
      localStorage.removeItem("businessId");
    } catch (e) {
      console.error(e);
    }

    if (this.props.redirectTo) {
      if (this.props.redirectTo === "/business/login") {
        window.Intercom('shutdown');
      }

      this.props.history.push(this.props.redirectTo);
    }
    else {
      window.location = 'https://bambooapp.ie'
    }

  }

  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  }

  render() {
    return (
      <div
        onClick={this.signOut.bind(this)}
        className="sign-out-button"
      >
        <i className="fas fa-sign-out-alt"></i>
        Sign out
      </div>
    );
  }
}

const SignOutWithRouter = withRouter(SignOut);
export default SignOutWithRouter;